// import React, { useState, useEffect } from "react";
// import { Container, Row, Col, Modal, Button } from "react-bootstrap";
// import ImageGallery1 from "../assets/stones/7.jpeg";
// import ImageGallery2 from "../assets/stones/2.jpeg";
// import ImageGallery4 from "../assets/stones/4.jpeg";
// import ImageGallery5 from "../assets/stones/1.jpeg";
// import ImageGallery7 from "../assets/stones/9.jpeg";
// import ImageGallery9 from "../assets/stones/5.jpeg";
// import ImageGallery10 from "../assets/stones/10.jpeg";
// import ImageGallery11 from "../assets/stones/12.jpeg";
// import Navbar1 from "./Navbar";
// import { loadStripe } from "@stripe/stripe-js";
// import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

// // Caricamento delle API di Stripe
// const stripePromise = loadStripe(
//   "pk_test_51PlUd2RuGtfPRxanLfPZuKjRXeqzogfW1qfanK1hKoqmR3dOwSECCT2ilQ9ttQtYMltH7dNk0AEEeUkBB71zPMKq00oJYYNbgl"
// );

// // Modulo di Checkout con Stripe
// const CheckoutForm = ({ price }) => {
//   const stripe = useStripe();
//   const elements = useElements();

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     if (!stripe || !elements) {
//       return;
//     }

//     const card = elements.getElement(CardElement);
//     const result = await stripe.createToken(card);

//     if (result.error) {
//       console.log(result.error.message);
//     } else {
//       console.log(result.token);
//       // Invia il token al tuo server
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <CardElement />
//       <Button
//         variant="primary"
//         type="submit"
//         disabled={!stripe}
//         style={{ backgroundColor: "black", borderColor: "black" }}
//       >
//         Acquista {price}
//       </Button>
//     </form>
//   );
// };

// // Componente principale Stones
// const Stones = () => {
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   // Scrolla la pagina verso l'alto quando il componente viene montato
//   useEffect(() => {
//     window.scrollTo({ top: 0, left: 0, behavior: "instant" });
//   }, []);

//   const handleItemClick = (item) => {
//     setSelectedItem(item);
//     setShowModal(true);
//   };

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("is-visible");
//             observer.unobserve(entry.target);
//           }
//         });
//       },
//       {
//         threshold: 0.1,
//       }
//     );

//     document.querySelectorAll(".gallery-item").forEach((item) => {
//       observer.observe(item);
//     });

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <>
//       <Navbar1 />

//       <section className="photo-gallery py-5" style={{ marginTop: "30px" }}>
//         <Container className="mt-4 mb-4">
//           <Row>
//             {[
//               {
//                 image: ImageGallery1,
//                 description: "Esemplare di granato taglio ovale, pietra di 13,55 carati proveniente dallo Sri Lanka ",
//                 price: "€473",
//               },
//               {
//                 image: ImageGallery2,
//                 description: "Esemplare di ametista taglio ovale, pietra di 33,61 carati proveniente dallo Sri Lanka",
//                 price: "€198",
//               },

//               {
//                 image: ImageGallery4,
//                 description:
//                   "Esemplare di quarzo limone taglio ovale, pietra di 9,5 carati proveniente dallo Sri Lanka",
//                 price: "€33",
//               },
//               {
//                 image: ImageGallery5,
//                 description:
//                   "Esemplare di topazio azzurro, talio a pera, pietra di  carati proveniente dallo Sri Lanka",
//                 price: "€68",
//               },

//               {
//                 image: ImageGallery7,
//                 description:
//                   "Esemplare di Diamante taglio Marquise di 0,30 carati completo di incisione laser e certificato. ",
//                 price: "€370",
//               },

//               {
//                 image: ImageGallery9,
//                 description: "Esemplare di Ametista di 15,86 carati provenienza Afghanistan. ",
//                 price: "€92",
//               },
//               {
//                 image: ImageGallery10,
//                 description: "Esempplare di crisoberillo taglio smeraldo pietra di 4,27 carati",
//                 price: "€155",
//               },
//               {
//                 image: ImageGallery11,
//                 description: "Esemplare di topazio azzurro di 6,3 carati, pietra proveniente dallo Sri Lanka",
//                 price: "€33",
//               },
//             ].map((item, index) => (
//               <Col key={index} xs={12} sm={6} md={3} className="mb-4">
//                 <div className="gallery-item" onClick={() => handleItemClick(item)}>
//                   <img src={item.image} alt={`Gallery ${index + 1}`} className="gallery-image" />
//                 </div>
//               </Col>
//             ))}
//           </Row>
//         </Container>
//       </section>

//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Descrizione della Pietra</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selectedItem && (
//             <>
//               <img src={selectedItem.image} alt="Selected" className="img-fluid mb-3" />
//               <p>{selectedItem.description}</p>
//               <p>
//                 <strong>Prezzo: {selectedItem.price}</strong>
//               </p>
//               <Elements stripe={stripePromise}>
//                 <CheckoutForm price={selectedItem.price} />
//               </Elements>
//             </>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Chiudi
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default Stones;

import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import ImageGallery1 from "../assets/stones/7.jpeg";
import ImageGallery2 from "../assets/stones/2.jpeg";
import ImageGallery4 from "../assets/stones/4.jpeg";
import ImageGallery5 from "../assets/stones/1.jpeg";
import ImageGallery7 from "../assets/stones/9.jpeg";
import ImageGallery9 from "../assets/stones/5.jpeg";
import ImageGallery10 from "../assets/stones/10.jpeg";
import ImageGallery11 from "../assets/stones/12.jpeg";
import ImageGallery12 from "../assets/stones/b.jpeg";
import Navbar1 from "./Navbar";

// Componente principale Stones
const Stones = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Scrolla la pagina verso l'alto quando il componente viene montato
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  const handleItemClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    document.querySelectorAll(".gallery-item").forEach((item) => {
      observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Navbar1 />

      <section className="photo-gallery py-5" style={{ marginTop: "30px" }}>
        <Container className="mt-4 mb-4">
          <Row>
            {[
              {
                image: ImageGallery1,
                description: "Esemplare di granato taglio ovale, pietra di 13,55 carati proveniente dallo Sri Lanka",
                price: "€473",
                link: "https://www.ebay.it/itm/356157691901?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery2,
                description: "Esemplare di ametista taglio ovale, pietra di 33,61 carati proveniente dallo Sri Lanka",
                price: "€198",
                link: "https://www.ebay.it/itm/356157729010?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery4,
                description:
                  "Esemplare di quarzo limone taglio ovale, pietra di 9,5 carati proveniente dallo Sri Lanka",
                price: "€33",
                link: "https://www.ebay.it/itm/356157743679?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery5,
                description:
                  "Esemplare di topazio azzurro, taglio a pera, pietra di 8 carati proveniente dallo Sri Lanka",
                price: "€68",
                link: "https://www.ebay.it/itm/356157761719?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery7,
                description: "Esemplare di Diamante taglio Marquise di 0,30 carati completo di incisione laser",
                price: "€370",
                link: "https://www.ebay.it/itm/356157769686?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery9,
                description: "Esemplare di Ametista di 15,86 carati provenienza Afghanistan",
                price: "€92",
                link: "https://www.ebay.it/itm/356157779164?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery10,
                description: "Esemplare di crisoberillo taglio smeraldo pietra di 4,27 carati",
                price: "€155",
                link: "https://www.ebay.it/itm/356157822559?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery11,
                description: "Esemplare di topazio azzurro di 6,3 carati, pietra proveniente dallo Sri Lanka",
                price: "€33",
                link: "https://www.ebay.it/itm/356157837907?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery12,
                description:
                  "Lotto di due esemplari di Fluorite blu viola con cambio di colore. Pietre di 6,66 carati con taglio rotondo. Certificate.",
                price: "€192",
                link: "https://www.ebay.it/itm/356234879977?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
            ].map((item, index) => (
              <Col key={index} xs={12} sm={6} md={3} className="mb-4">
                <div className="gallery-item" onClick={() => handleItemClick(item)}>
                  <img src={item.image} alt={`Gallery ${index + 1}`} className="gallery-image" />
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Descrizione della Pietra</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <>
              <img src={selectedItem.image} alt="Selected" className="img-fluid mb-3" />
              <p>{selectedItem.description}</p>
              <p>
                <strong>Prezzo: {selectedItem.price}</strong>
              </p>

              {/* Aggiungi il bottone per acquistare il prodotto su un link esterno */}
              <Button
                variant="primary"
                onClick={() => window.open(selectedItem.link, "_blank")}
                style={{ backgroundColor: "black", borderColor: "black" }}
              >
                Acquista
              </Button>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Stones;
